import { render } from "./returnCar.vue?vue&type=template&id=0a6dc8ca&scoped=true"
import script from "./returnCar.vue?vue&type=script&lang=js"
export * from "./returnCar.vue?vue&type=script&lang=js"

import "./returnCar.vue?vue&type=style&index=0&id=0a6dc8ca&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6dc8ca"]])

export default __exports__